import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { TYPE_COPY_LINK_CHAIN, TYPE_SHARE_NODES } from '../../config/icon-types';
import { LABELS } from '../../config/data';
import { copyUrlToClipboard } from '../../utility/url';
import './style.css';

/**
 * Renders a modal containing a link to the latest selected sensor solution
 * @param {*} props Props passed to this component
 * @param {*} modalRef Ref that will connect this modal to its parent component
 * @returns {React.ReactComponentElement} Share Design Modal Component
 */
const ShareDesignModal = forwardRef(function ShareDesignModal(props, modalRef) {
	const classes = ['adi-isp__share-design-modal'];
	const { designUrl } = props;
	const { shareDesignModalTitle, shareDesignModalMessage, copyLinkButton } = LABELS;

	/**
	 * Copies the current design url to clipboard
	 */
	const copyDesignUrlToClipboard = () => {
		copyUrlToClipboard(designUrl);
	};

	return (
		<div
			className="modal fade"
			ref={modalRef}
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div className="modal-dialog" style={{ transform: 'translateY(70%)' }}>
				<div className="modal-content">
					<section className={classes.join(' ')}>
						<header className={`${classes[0]}-header`}>
							<p className={`${classes[0]}-title`}>
								<Icon type={TYPE_SHARE_NODES} />
								<span>{shareDesignModalTitle}</span>
							</p>
							<i
								className={`${classes[0]}-close-button fa fa-close fa-2x`}
								data-dismiss="modal"
							/>
						</header>
						<div className={`${classes[0]}-body`}>
							<p className={`${classes[0]}-message`}>
								{shareDesignModalMessage}
							</p>

							<div className={`${classes[0]}-design-link`}>
								<input
									type="url"
									readOnly
									value={designUrl}
									className={`${classes[0]}-design-url`}
								/>

								<button
									onClick={copyDesignUrlToClipboard}
									data-dismiss="modal"
									className={`${classes[0]}-copy-link-button`}
								>
									<span>{copyLinkButton}</span>
									<Icon type={TYPE_COPY_LINK_CHAIN} />
								</button>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
});

ShareDesignModal.propTypes = {
	designUrl: PropTypes.string.isRequired,
};

export default ShareDesignModal;
